import styled from "styled-components";

export const StyledHome = styled.div`
    
    .header{
        position: relative;
        overflow: hidden;
        .main-video{
            position: absolute;
            min-height: 100%;
            min-width: 100%;
            z-index: -2;
        }
        .shadow{
            position: absolute;
            width: 100%;
            top:0;
            z-index: -1;
            background-color: rgba(0,0,0,0.4);
            height: 100%;
        }
        

        .main-info{
            padding: 300px 80px 250px 80px;
            text-align: center;

            h1{
                font-weight: 700;
                font-size: 48px;
                line-height: 67px;
                color: #FFFFFF;
            }
            p{
                font-size: 24px;
                line-height: 33px;
                color: #FFFFFF;
                margin-top: 30px;
                margin-bottom: 40px;
            }
                a{
                    background: rgba(255, 255, 255, 0.05);
                    border: 3px solid #FFFFFF;
                    padding: 25px 80px;
                    border-radius: 12px;
                    cursor: pointer;
                    font-weight: 700;
                    font-size: 20px;
                    line-height: 27px;
                    color: #FFFFFF;
                    text-decoration: none;
                    display: inline-block;
                    &:hover{
                        background-color: #BB0600;
                        border-color: #BB0600;
                    }
                }
        }

        .chat-wrapper{
            display: flex;
            justify-content: flex-end;
            padding: 0 100px 60px 0;

            .chat{
                width: 100px;
                height: 100px;
                background-color: #BB0600;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 50%;
            }
        }
       
        @media (max-width: 1200px) {
            .main-info{
                padding: 250px 0 100px 0 ;

                h1{
                    font-size: 40px;
                    line-height: 50px;
                }
            }
        }

        @media (max-width: 768px) {
            .chat-wrapper{
                display: none;
            }
            .main-info{
                padding: 250px 0 200px;

                h1{
                    font-size: 30px;
                    line-height: 40px;
                }
                p{
                    font-size: 16px;
                }
                a{
                    padding: 16px 40px;
                }
            }
        }
        @media (max-width: 576px) {

            .main-info{
                padding: 250px 0;

                h1{
                    font-size: 20px;
                    line-height: 30px;
                }
                p{
                    margin-top: 15px;
                    font-size: 16px;
                    line-height: 22px;
                }
                a{
                    padding: 16px 40px;
                    font-size: 16px;
                }
            }
        }
    }
    
    .section-one{
        padding-top: 80px;
        display: flex;
        gap: 50px;
        justify-content: space-between;

        .right{
            margin-top: 120px;
            width: 50%;

        }
        .left{
            width: 50%;
        }
        .card{
            &:hover{
                .card-info{
                    box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.25);
                }
                .card-img{
                    .second-img{
                        right: 15px;
                        transition: all 0.4s ease-out;
                    }
                }
            }
            margin-bottom: 50px;
            .card-img{
                width: 100%;
                position: relative;
                img:first-child{
                    width: 100%;
                }

                .second-img{
                    position: absolute;
                    width: 70%;
                    right:0;
                    bottom: -25%;
                    transition: all 0.4s ease-out;
                }
            }
            .card-info{
                background: #FFFFFF;
                border: 1.3px solid #D8D8D8;
                border-radius: 0px 0px 10px 10px;
                padding: 40px;
                margin-top: -5px;
                transition: all 0.4s ease-out;


                h3{
                    font-weight: 600;
                    font-size: 40px;
                    line-height: 54px;
                    margin-top: 25px;
                }
                p{
                    font-size: 22px;
                    line-height: 37px;
                    margin-top: 15px;
                }
            }
        }

        @media (max-width: 1200px) {
            .card{
                .card-info{
                    padding: 20px;
                    h3{
                        font-size: 28px;
                        line-height: 36px;
                    }
                    p{
                        font-size: 16px;
                        line-height: 22px;
                    }
                }
            }
        }
        @media (max-width:768px) {
            display: block;

            .left, .right{
                width: 100%;
            }
        }
        @media (max-width: 576px) {
            margin-bottom: 100px;
            .left, .right{
                margin-top: 0;
                .card{
                    width: 280px;
                    &:nth-child(2){
                        margin-left: auto
                    }
                    margin-bottom: 15px;

                    .card-info{
                        background: #F3F3F3;
                        svg{
                            width: 30px;
                            height: 30px;
                        }

                        h3{
                            font-size: 16px;
                            line-height: 22px;
                            margin-top: 15px;

                        }
                        p{
                            font-size: 14px;
                            line-height: 20px;
                        }
                    }
                }
            }
        }
    }

`